import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Router, route } from "preact-router";
import Config from "../config.jsx";
import Markdown from 'preact-markdown';

import GenericPage from "./generic-page";

export function Content() {
	return <GenericPage Component={ContentBody} />
}
export function Promo() {
	return <GenericPage Component={PromoBody} />
}

export function ContentBody() {
	return <div class="flex max-w-7xl mx-auto min-h-[inherit]">
		<nav class="hidden md:block max-w-xs w-full bg-slate-200 text-slate-950 shrink-0">
			<Accordion open={true}>
				<MenuButton><Trans>Main</Trans></MenuButton>
				<div>
					<SubmenuEntry href="/content/main/about"><Trans>About Us</Trans></SubmenuEntry>
					<SubmenuEntry href="/contacts"><Trans>Contact Us</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/main/work-with-us"><Trans>Work With Us</Trans></SubmenuEntry>
				</div>
			</Accordion>
			<Accordion open={true}>
				<MenuButton><Trans>Products</Trans></MenuButton>
				<div>
					<SubmenuEntry href="/content/products/casino"><Trans>Casino</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/products/sportsbook"><Trans>Sportsbook</Trans></SubmenuEntry>
				</div>
			</Accordion>
			<Accordion open={true}>
				<MenuButton><Trans>Terms and Regulations</Trans></MenuButton>
				<div>
					<SubmenuEntry href="/content/terms/privacy"><Trans>Privacy Policy</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/terms/gambling"><Trans>Responsible Gaming</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/terms/sport-rules"><Trans>Sport Betting Rules</Trans></SubmenuEntry>
					<SubmenuEntry href="/content/terms/conditions"><Trans>Terms & Conditions</Trans></SubmenuEntry>
				</div>
			</Accordion>
		</nav>
		<div class="bg-slate-50 text-slate-950 grow min-w-0">
			<Router>
				<PathBasedCMSText path="/content/main/about" />
				<PathBasedCMSText path="/contacts" />
				<PathBasedCMSText path="/content/main/work-with-us" />

				<PathBasedCMSText path="/content/products/casino" />
				<PathBasedCMSText path="/content/products/sportsbook" />

				<PathBasedCMSText path="/content/terms/privacy" />
				<PathBasedCMSText path="/content/terms/gambling" />
				<PathBasedCMSText path="/content/terms/sport-rules" />
				<PathBasedCMSText path="/content/terms/conditions" />
			</Router>
		</div>
	</div>
}


export function PromoBody() {
	return <div class="flex max-w-7xl mx-auto min-h-[inherit]">
		<nav class="hidden md:block max-w-xs w-full bg-slate-200 text-slate-950 shrink-0">
			<Accordion open={true}>
				<MenuButton><Trans>Main</Trans></MenuButton>
				<div>
					<SubmenuEntry href="/promo/registration-bonus"><Trans>Registration Bonus</Trans></SubmenuEntry>
					<SubmenuEntry href="/promo/bets-bonus"><Trans>Accumulator Bonus</Trans></SubmenuEntry>
					<SubmenuEntry href="/promo/cash-back"><Trans>Cashback Bonus</Trans></SubmenuEntry>
					<SubmenuEntry href="/promo/products/betbuilder"><Trans>MultiBet vs. Betbuilder</Trans></SubmenuEntry>
					<SubmenuEntry href="/promo/live-casout"><Trans>Cashout</Trans></SubmenuEntry>
					<SubmenuEntry href="/promo/casino-cash-back"><Trans>Daily Cashback</Trans></SubmenuEntry>
					<SubmenuEntry href="/promo/victory-vault"><Trans>Victory Vault</Trans></SubmenuEntry>
				</div>
			</Accordion>
		</nav>
		<div class="bg-slate-50 text-slate-950 grow min-w-0">
			<Router>
				<PromosList default={true} />

				<PathBasedCMSText path="/promo/registration-bonus" />
				<PathBasedCMSText path="/promo/bets-bonus" />
				<PathBasedCMSText path="/promo/cash-back" />
				<PathBasedCMSText path="/promo/casino-cash-back" />
				<PathBasedCMSText path="/promo/live-casout" />
				<PathBasedCMSText path="/promo/products/betbuilder" />
				<PathBasedCMSText path="/promo/victory-vault" />
			</Router>
		</div>
	</div>
}

class Accordion extends Component {
	state = { open: !!this.props.open }
	render({ children }) {
		return <Fragment>
			<div onClick={e => this.setState({ open: !this.state.open })}>{children[0]}</div>
			{this.state.open ? children[1] : null}
		</Fragment>
	}
}

function MenuButton({ children }) {
	return <div class="h-8 bg-blue-whale-600 text-white border-b border-blue-whale-900 pl-4 flex items-center text-sm">{children}</div>
}
function SubmenuEntry({ children, href }) {
	return <a class="h-8 bg-blue-whale-700 text-white border-b border-blue-whale-950 pl-8 flex items-center text-sm hover:bg-blue-whale-800" href={href}>{children}</a>
}

function PathBasedCMSText({ path }) {
	return <CMSText path={path} key={path} />
}
export class CMSText extends Component {
	state = { content: null, loading: true };
	componentWillMount() {
		this.downloadMarkdownPage(this.props.path).then(content => {
			this.setState({ loading: false, content });
		}).catch(e => {
			this.setState({ loading: false })
		})
	}
	async downloadMarkdownPage(path) {
		const req = await fetch(Config.softionAPI + '/cms/get?json&lang=' + Config.lang + '&public=&path=' + path);
		const body = await req.json();
		return body.data;
	}
	render({ path }) {
		if (this.state.loading)
			return <div class="pt-6 text-3xl text-slate-300 text-center"></div>
		if (!this.state.content)
			return <div class="pt-6 text-3xl text-slate-300 text-center">
				<Trans>Page not found</Trans>
			</div>
		return <div class="pt-3 text-base px-4 prose prose-slate lg:prose-lg max-w-full">
			<Markdown markdown={this.state.content} />
		</div>
	}
}

function PromosList() {
	return <div class="pt-4">
		<div class="p-6 flex flex-col md:grid md:grid-cols-2 gap-6">

			<div class="rounded shadow-xl flex relative bg-slate-50 text-slate-950">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/toto-promo/AccBonus1.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>ACCUMULATOR BONUS WIN UP TO 400%</div>
				</div>
				<a class="bg-kobaaccent-400 text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/bets-bonus">Read More</a>
			</div>

			<div class="rounded shadow-xl flex relative bg-slate-50 text-slate-950">
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Refund bonus</div>
				</div>
				<a class="bg-kobaaccent-400 text-black w-36 rounded absolute left-2 bottom-3 text-center py-1" href="/promo/cash-back">Read More</a>
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -right-3 rounded shadow bg-black bg-[url(../img/toto-promo/refundbonus1.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
			</div>

			<div class="rounded shadow-xl flex relative bg-slate-50 text-slate-950">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/toto-promo/betbuilder1.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Multibet vs. BetBuilder</div>
				</div>
				<a class="bg-kobaaccent-400 text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/products/betbuilder">Read More</a>
			</div>

			<div class="rounded shadow-xl flex relative bg-slate-50 text-slate-950">
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Cashout</div>
				</div>
				<a class="bg-kobaaccent-400 text-black w-36 rounded absolute left-2 bottom-3 text-center py-1" href="/promo/live-casout">Read More</a>
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -right-3 rounded shadow bg-black bg-[url(../img/toto-promo/cashout.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
			</div>

			<div class="rounded shadow-xl flex relative bg-slate-50 text-slate-950">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/toto-promo/daily_cash_15_50PM.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Daily Cashback on Casino</div>
				</div>
				<a class="bg-kobaaccent-400 text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/casino-cash-back">Read More</a>
			</div>

			<div class="rounded shadow-xl flex relative bg-slate-50 text-slate-950">
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Registration Bonus</div>
				</div>
				<a class="bg-kobaaccent-400 text-black w-36 rounded absolute left-2 bottom-3 text-center py-1" href="/promo/registration-bonus">Read More</a>
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -right-3 rounded shadow bg-black bg-[url(../img/toto-promo/freebonus.jpg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
			</div>

			<div class="rounded shadow-xl flex relative bg-slate-50 text-slate-950">
				<div class="aspect-square h-48">
					<div class="w-full h-full relative -top-3 -left-3 rounded shadow bg-black bg-[url(../img/toto-promo/victory-vault.svg)] bg-contain bg-no-repeat bg-center"></div>
				</div>
				<div class="grow pt-4 pb-2 justify-between px-2 text-xl font-light">
					<div>Victory Vault</div>
				</div>
				<a class="bg-kobaaccent-400 text-black w-36 rounded absolute right-2 bottom-3 text-center py-1" href="/promo/victory-vault">Read More</a>
			</div>

		</div>
	</div>
}